import { useSpring } from "@react-spring/web";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useMeasure from "react-use-measure";

import {
  STYLE_NOT_EXIST_BUTTON_ACTIVATION_TIME,
  STYLE_NOT_EXIST_BUTTON_EXPIRED_TIME,
  STYLE_NOT_EXIST_MODAL_EXPIRED_TIME,
  TranslationContext,
} from "@is/constants";
import { ScannerContext } from "@is/contexts/ScannerContext";

type Props = {
  onClose: () => void;
};

const useManageStyleNotExistModal = ({ onClose }: Props) => {
  const { t } = useTranslation(TranslationContext.General);

  const [startStyleNotExistProgressBar, setStartStyleNotExistProgressBar] =
    useState<boolean>(false);

  const { scannedValue } = useContext(ScannerContext);

  const [animatedRef, { width }] = useMeasure();
  const styles = useSpring({
    width: startStyleNotExistProgressBar ? width : 0,
    config: {
      duration: startStyleNotExistProgressBar
        ? STYLE_NOT_EXIST_BUTTON_EXPIRED_TIME
        : 0,
    },
  });

  const handleCloseModal = useCallback(() => {
    setStartStyleNotExistProgressBar(false);

    if (typeof onClose === "function") {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartStyleNotExistProgressBar(true);
    }, STYLE_NOT_EXIST_BUTTON_ACTIVATION_TIME);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleCloseModal();
    }, STYLE_NOT_EXIST_MODAL_EXPIRED_TIME);

    return () => clearTimeout(timer);
  }, [handleCloseModal]);

  return {
    handleCloseModal,
    animatedRef,
    styles,
    scannedValue,
    t,
  };
};

export default useManageStyleNotExistModal;
